// 添加组织
import request from "@/utils/interceptor.js";

export const editPassword = (id,data) => {
  return request({
    url: `/api/pas/user/${id}/password`,
    method: "put",
    data,
  });
};
